export default __webpack_public_path__ + "static/media/beetle.2c15b7a2.png";